"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _HiFormControl = _interopRequireDefault(require("../HiForm/HiFormControl"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _stylesheet = _interopRequireDefault(require("./stylesheet"));
var _classnames = _interopRequireDefault(require("classnames"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _HiInput = _interopRequireDefault(require("../HiForm/HiInput"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var HiDatePickerMobile = /*#__PURE__*/function (_React$Component) {
  function HiDatePickerMobile() {
    (0, _classCallCheck2.default)(this, HiDatePickerMobile);
    return _callSuper(this, HiDatePickerMobile, arguments);
  }
  (0, _inherits2.default)(HiDatePickerMobile, _React$Component);
  return (0, _createClass2.default)(HiDatePickerMobile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        id = _this$props.id,
        label = _this$props.label,
        required = _this$props.required,
        disabled = _this$props.disabled,
        error = _this$props.error,
        errorText = _this$props.errorText,
        helperIcon = _this$props.helperIcon,
        helperText = _this$props.helperText,
        enableTime = _this$props.enableTime,
        value = _this$props.value,
        disablePastDays = _this$props.disablePastDays,
        disableFutureDays = _this$props.disableFutureDays,
        minimumDate = _this$props.minimumDate,
        today = _this$props.today,
        range = _this$props.range,
        format = _this$props.format;
      var addtionalProps = (0, _objectSpread2.default)({}, this.props.disabled && {
        disabled: "disabled"
      });
      return /*#__PURE__*/_react.default.createElement(_HiFormControl.default, {
        id: id,
        label: label,
        required: required,
        disabled: disabled,
        error: error,
        errorText: errorText,
        helperText: helperText,
        helperIcon: helperIcon
      }, /*#__PURE__*/_react.default.createElement(_HiInput.default, {
        inputId: id,
        name: id,
        type: "text",
        placeholder: this.props.placeholder,
        value: !value ? '' : (0, _momentTimezone.default)(value).format(format),
        disabled: disabled
      }), /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, classes.rootMobile, (0, _defineProperty2.default)({}, classes.mobileRangeRoot, range)),
        id: id,
        type: enableTime ? "datetime-local" : "date",
        value: !value ? '' : enableTime ? (0, _momentTimezone.default)(value).format('YYYY-MM-DDTHH:mm') : (0, _momentTimezone.default)(value).format('YYYY-MM-DD'),
        onChange: this.props.onChange,
        min: disablePastDays ? today.format('YYYY-MM-DD') : minimumDate ? (0, _momentTimezone.default)(minimumDate).format('YYYY-MM-DD') : '',
        max: disableFutureDays ? today.format('YYYY-MM-DD') : ''
      }, addtionalProps)));
    }
  }]);
}(_react.default.Component);
var _default = exports.default = (0, _withStyles.default)(_stylesheet.default)(HiDatePickerMobile);